import blpAuth from './blp-auth';
import { getPlatformApiHost, getSyncHost } from '../utils/hosts';
import logger from '../utils/logger-rum';

export async function startLimitedInputAuth() {
	return fetch(`${getSyncHost()}/limited-input/start`, {
		method: 'POST',
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		logger.error(error);
	});
}

export async function checkLimitedInputAuth(sessionId: string, uniqueCode: string) {
	return fetch(`${getSyncHost()}/limited-input/check?sessionId=${sessionId}&uniqueCode=${uniqueCode}`, {
		method: 'GET',
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		logger.error(error);
	});
}

export async function authorizeLimitedInput(
	authCode: string,
	redirectToRoom: string,
): Promise<boolean> {
	return fetch(`${getPlatformApiHost()}/v4/admin/auth/limited-input/authorize?uniqueCode=${authCode}&redirectToRoom=${encodeURIComponent(redirectToRoom)}`, {
		method: 'POST',
		headers: {
			Authorization: blpAuth.accessToken ? `Bearer ${blpAuth.accessToken}` : undefined,
		},
		credentials: blpAuth.accessToken ? undefined : 'include', // needed for cookie auth
	} as RequestInit)
		.then((res) => !!res.ok)
		.catch((error) => {
			logger.error(error);
			return false;
		});
}
